export default "__VITE_ASSET__BFZC2mjf__"